import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changePage } from "~/features/search/redux/actions";
import { selectProductPageAmount, selectProductResultAmount } from "~/features/search/redux/searchSelectors";
import { selectCurrentPage } from "./ProductResults";

export const useSearchPagination = (): {
  pageAmount: number;
  currentPage: number;
  onPageChanged: (newPageNumber: number) => void;
  totalResults: number;
} => {
  const dispatch = useDispatch();
  const pageAmount = useSelector(selectProductPageAmount);
  const currentPage = useSelector(selectCurrentPage);
  const totalResults = useSelector(selectProductResultAmount);

  const onPageChanged = useCallback(
    (newPageNumber: number) => {
      dispatch(changePage(newPageNumber));
      window.scrollTo(0, 0);
    },
    [dispatch],
  );

  return {
    pageAmount,
    currentPage,
    onPageChanged,
    totalResults,
  };
};
